import {
    React, RouteComponentProps,
    Formsy, form, formHelpers,
    i18n, sparda,
    observable, inject, observer,
    mui, ui, theme, pr,
    debug
} from "aaa";
import { User } from "models/User";
import * as _ from "lodash";

type IProps = i18n.InjectedIntlProps & {
    user: User
};

@i18n.injectIntl
@inject("user")
@observer
export class ContactContent extends React.Component<IProps, {}> {

    render() {
        return (
            <div>
                <form.FormsyText
                    name="phoneNumber"
                    validations="isPhoneNumber"
                    floatingLabelText={ui.__("contact.phoneNumber")}
                    fullWidth={true}
                    value={this.props.user.phoneNumber}
                    validationError={ui.__("error.phoneNumberInvalid")}
                />

                <pr.InfoText style={{ zIndex: 10 }}>
                    {ui.__("contact.phoneNumber.info")}
                </pr.InfoText>


                <form.FormsyText
                    name="emailAddress"
                    required
                    validations="isEmail"
                    floatingLabelText={ui.__("contact.emailAddress")}
                    fullWidth={true}
                    value={this.props.user.emailAddress}
                    validationError={ui.__("error.emailInvalid")}
                />

                <pr.InfoText style={{ zIndex: 10 }}>
                    {ui.__("contact.emailAddress.info")}
                </pr.InfoText>


                <form.FormsyText
                    name="iban"
                    required={true}
                    validations="isIBAN"
                    floatingLabelText={ui.__("contact.iban")}
                    fullWidth={true}
                    value={this.props.user.iban}
                    validationError={ui.__("error.ibanInvalid")}
                    onChange={(event: any, value: string) => {
                        // Remove all whitespace
                        value = value.replace(/ /g, "");
                        // Add space at every 4th character
                        value = value.replace(/(\S{4})/g, "$1 ");
                        // Trim any trailing whitespace
                        this.props.user.iban = value.trim();
                    }}
                />
                <pr.InfoText style={{ zIndex: 10 }}>
                    {ui.__("contact.iban.info")}
                </pr.InfoText>

                <form.FormsyCheckbox
                    style={{ marginTop: theme.MARGIN }}
                    name="phoneAllowed"
                    labelPosition="left"
                    label={ui.__("contact.phoneAllowed")}
                    defaultChecked={this.props.user.phoneAllowed}
                />
            </div >
        );
    }
}


@i18n.injectIntl
@inject("user")
@observer
export class ContactForm extends React.Component<RouteComponentProps<{}> & IProps & { onSubmit: (keysSubmittedFields: string[]) => void }, {}> {

    @observable
    formIsValid = true;

    private formRef: any;

    static parseInput(user: User, fields: any) {
        user.phoneNumber = fields.phoneNumber;
        user.emailAddress = fields.emailAddress;
        user.iban = fields.iban;
        user.phoneAllowed = fields.phoneAllowed;
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        // SUCCESS-REDIRECT: user has already fully submitted previously, hard redirect to /loan
        if (this.props.user.successfullySubmitted === true) {
            window.location.replace(window.location.origin + window.location.pathname); // we wont include hash - root page only.
        }
    }

    onSubmit = (fields: any, resetForm: any, invalidateForm: any) => {
        const user = this.props.user;
        ContactForm.parseInput(user, fields);
        debug.log("### Contact user", user);

        const submittedFields = _.compact(_.map(fields as _.Dictionary<any>, (value, key) => {
            return _.isNil(value) ? null : key;
        }));

        this.props.onSubmit(submittedFields);

        this.props.history.push("/income");
    }

    render() {
        return (
            <pr.FormContainer>
                <Formsy.Form
                    onInvalidSubmit={(fields: any, reset: any, invalidate: any) => formHelpers.invalidateRequiredFields(this.formRef, invalidate)}
                    onValidSubmit={this.onSubmit}
                    onValid={() => { this.formIsValid = true; }}
                    onInvalid={() => { this.formIsValid = false; }}
                    noValidate
                    ref={(c: any) => this.formRef = c}
                >
                    <ContactContent user={this.props.user} />
                    {formHelpers.renderActionButton(ui.__("continue"))}
                </Formsy.Form>
            </pr.FormContainer >
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ContactForm.tsx